
import { canonical } from "@utils";
export default {
	name: "About",
	async asyncData({ $axios }) {
		const pageURL = `https://api.ltkcontent.com/core/v1/page/about?site=wf`;
		const { data, status } = await $axios.get(pageURL);

		return {
			node: status === 200 && data.data ? data.data : {},
		};
	},
	head() {
		return {
			title: "About WordFinder by YourDictionary: Who We Are and What We Do",
			meta: [
				{
					name: "description",
					content:
						"WordFinder by YourDictionary is the resource word game fans trust to help them win. Learn all about how we got started, our mission and our team in this overview.",
				},
			],
			link: [canonical(this.$route)],
		};
	},
	computed: {
		showComponent() {
			return !!(this.node?.template || this.node?.component);
		},
	},
	mounted() {
		setTimeout(() => {
			const hash = this.$route.hash;
			if (hash) {
				this.$goToHash(hash.substring(1));
			}
		}, 300);
	},
};
